
export const PLEASE_ENTER_PHONE = 'Please enter phone number.';
export const PLEASE_ENTER_VALID_PHONE = 'Please enter phone valid number.';

export const PLEASE_ENTER_FIRST_NAME = 'Please enter first name.';
export const PLEASE_ENTER_VALID_FIRST_NAME = 'Please enter valid first name.';
export const PLEASE_ENTER_LAST_NAME = 'Please enter last name.';
export const PLEASE_ENTER_VALID_LAST_NAME = 'Please enter valid last name.'

export const PLEASE_ENTER_EMAIL = 'Please enter email.';
export const PLEASE_ENTER_VALID_EMAIL = 'Please enter valid email address.';

export const PLEASE_ENTER_PASSWORD = 'Please enter password.';
export const PLEASE_ENTER_CONFIRM_PASSWORD = 'Please enter confirm password.';
export const PLEASE_ENTER_PASSWORD_LENGTH = 'Password should be between 6 to 15 characters.';
export const PLEASE_ENTER_CONFIRM_PASSWORD_LENGTH = 'Password should be between 6 to 15 characters.';


export const NO_RECORDS_FOUND = 'No records found.';
export const PLEASE_ENTER_TEXT_TYPE = 'Please enter text type.';

export const PLEASE_ENTER_VALID_TEXT_LENGTH = 'Text length should not greater than :value.';
export const DFSFS = 'sdfsdfsdfs';
